import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SmartCardCommunicationService } from '../../../smart-card/services/smart-card-communication.service';

@Component({
  selector: 'app-choice-partner-type',
  templateUrl: './choice-partner-type.component.html',
  styleUrls: ['./choice-partner-type.component.css']
})
export class ChoicePartnerTypeComponent implements OnInit, OnDestroy {

  @Output()
  eventEmployee = new EventEmitter();

  @Output()
  eventGuest = new EventEmitter();

  disableGuest = false;

  private statusSubscription: Subscription;

  constructor(
    private smartCardCommunicationService: SmartCardCommunicationService,
  ) { }

  ngOnInit() {
    this.disableGuest = true;
    this.statusSubscription = this.smartCardCommunicationService.getStatus().subscribe(
      status => {
        this.disableGuest = !status || !status.isCardAvailable;
      }
    );
  }

  ngOnDestroy() {
    if (this.statusSubscription) {
      this.statusSubscription.unsubscribe();
      this.statusSubscription = null;
    }
  }

  onEmployeeClick(): void {
    this.eventEmployee.emit();
  }

  onGuestClick(): void {
    if (this.disableGuest) {
      return;
    }
    this.eventGuest.emit();
  }

  getChangeFontSizeClass(text: string): string {
    return text && text.length > 12 ? 'fontSizeTitle' : '';
  }
}
